export default __webpack_public_path__ + "static/media/two-phones.7c032273.png";